<template>
  <v-container>
    <v-btn
      color="primary"
      :disabled="errors.any() || isInProgressorSigned(application) || application.relocationID==0"
      @click="sendApplication(index, application)"
    >Send To Customer</v-btn>
    <v-btn
      color="primary"
      :disabled="errors.any() || isInProgressorSigned(application)"
      @click="save(index, application.relocationDetails)"
    >Save</v-btn>
    <v-btn
      color="primary"
      :disabled="errors.any() || application.status !=='In Progress'"
      @click="reset(index, application.relocationDetails)"
    >Reset to Edit</v-btn>
  </v-container>
</template>

<script>
export default {
  name: "UtilityAction",
  props: {
    sendInactive: Boolean,
    saveInactive: Boolean,
    resetInactive: Boolean,
    inactive: Boolean,
    application: Object
  },
  data() {
    return {};
  },

  methods: {}
};
</script>

<style>
</style>
